window.pageHeightControl={
    calcHeight: () => {
        let $w=$(window),
            $n=$('#main-menu'),
            $s=$('#content'),
            $f=$('body > footer:first');
        return (
            $w.height() - (
                $n.outerHeight() +
                parseInt($s.css('padding-top')) +
                parseInt($s.css('padding-bottom')) +
                // DON'T USE MARGIN-TOP BECAUSE OF THE FIXED NAVBAR
                parseInt($s.css('margin-bottom')) +
                parseInt($f.outerHeight())
            )
        );
    },
    setHeight: (h) => {
        if(h){
            $('#content').css({"min-height": h});
        }
    },
    load: () => {
        pageHeightControl.setHeight(pageHeightControl.calcHeight());
        $(window).resize(() => {
            pageHeightControl.setHeight(pageHeightControl.calcHeight());
        });
    }
};
pageHeightControl.load();